<template>
  <div>
    <b-card>
      <div class="details-tables">
        <div class="row">
          <div class="col-md-4">
            <table>
              <tbody>
                <tr>
                  <th>Periode</th>
                  <td>{{ dataCalculation.period }}</td>
                </tr>
                <tr>
                  <th>Tgl Awal</th>
                  <td>{{ FormatDate(dataCalculation.startDate) }}</td>
                </tr>
                <tr>
                  <th>Tgl Akhir</th>
                  <td>{{ FormatDate(dataCalculation.endDate) }}</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>{{ dataCalculation.status }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4">
            <table>
              <tbody>
                <tr>
                  <th>Progress Hitung Kehadiran</th>
                  <td>{{ DecodeStatus(dataCalculation.progressCalculateAttendance) }}</td>
                </tr>
                <tr>
                  <th>Progress Hitung Lembur</th>
                  <td>{{ DecodeStatus(dataCalculation.progressCalculateOvertime) }}</td>
                </tr>
                <tr>
                  <th>Progress Hitung Gaji</th>
                  <td>{{ DecodeStatus(dataCalculation.progressCalculatePayroll) }}</td>
                </tr>
                <tr>
                  <th>Pesan Error</th>
                  <td>{{ dataCalculation.message }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-4" v-if="tabs === 4">
            <b-overlay :show="isLoadingDownload" class="d-inline-block" spinner-small spinner-variant="primary">
              <b-button @click="DownloadSalary()" class="d-flex" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary">Download hasil Hitung Gaji</b-button>
            </b-overlay>
          </div>
        </div>
      </div>
      <div class="tabs">
        <b-tabs v-model="tabs" content-class="pt-1">
          <b-tab title="Kehadiran">
            <AtendanceTab />
          </b-tab>
          <b-tab title="Lembur">
            <OvertimeTab />
          </b-tab>
          <b-tab title="Upload Potongan">
            <UploadPieceTab />
          </b-tab>
          <b-tab title="Gaji">
            <SalaryTab />
          </b-tab>
          <b-tab title="Upload PPH">
            <UploadPPHTab :dataCalculation="dataCalculation" />
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
  </div>
</template>
<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput, BTabs, BTab, BOverlay } from "bootstrap-vue";
import AtendanceTab from '../../components/CalculationSalaryTabs/AtendanceTab';
import OvertimeTab from '../../components/CalculationSalaryTabs/OvertimeTab';
import UploadPieceTab from '../../components/CalculationSalaryTabs/UploadPieceTab';
import SalaryTab from '../../components/CalculationSalaryTabs/SalaryTab';
import UploadPPHTab from '../../components/CalculationSalaryTabs/UploadPPHTab'
import utility from '../../libs/utility';
import { successNotification, errorNotification } from "@/auth/utils";
export default {
  name: "CountSalaryView",
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTabs,
    BTab,
    AtendanceTab,
    OvertimeTab,
    UploadPieceTab,
    SalaryTab,
    UploadPPHTab,
    BOverlay
  },
  data() {
    return {
      tabs: 0,
      dataCalculation: {},
      isLoadingDownload: false
    }
  },
  directives: {
    Ripple,
  },
  methods: {
    /**
     * @return {string}
     */
    DecodeStatus(status) {
      if (status) {
        return 'Selesai';
      }
      if (!status) {
        return 'Progress';
      }
    },
    ListenWebSocket() {
      let router = this.$route;
      let data = {
        payslipId: router.params.id
      };
      utility.WebSocketConnection(data,(event) => {
        window.console.log(event.data);
        this.dataCalculation = event.data;
      });
    },
    FormatDate(date) {
      return utility.FormatDate(date);
    },
    DownloadSalary() {
      this.isLoadingDownload = true;
      let router = this.$route;
      let req = {
        payslipId: router.params.id
      };
      this.$http.get('/payslip/employee-payslip/all/download/excel', {params: req,responseType: 'blob'})
        .then((result) => {
          window.console.log(result);
          if (result.status === 200) {
            const url  = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `download hitung gaji ${new Date()}.xlsx`);
            document.body.appendChild(link);
            link.click();
          }
          this.isLoadingDownload = false;
        })
        .catch((e) => {
          this.isLoadingDownload = false;
          errorNotification(this, "Oops!", e.message);
        });
    },
  },
  mounted() {
    this.ListenWebSocket();
  }
}
</script>
